import React from 'react';
import { Col, Row, Table, Button } from 'react-bootstrap';
import LoadingScreen from '../../hoc/LoadingScreen';
import {formatTimestamp, timestampsDatesDifferent} from '../../util/parseDate';

const overview = (props) => {

  const selectedLocation = props.data.locations.filter((el) => {
    return el.id===props.data.selectedLocationId
  });

  const selectedServices = props.data.selectedServiceTypeIds.map((el) => {
    const serviceType = props.data.serviceTypes.filter((st) => {
      return st.id===el;
    });
    return (
      <span key={"summary-service-"+el} className="d-block">{serviceType[0].name}</span>
    );
  });

  let selectedMakeName = "";
  const selectedMake = props.data.vehicleMakes.filter(el => el.id===parseInt(props.data.vehicleInfo.data.make.value));
  if(selectedMake.length>0){
    selectedMakeName = selectedMake[0].name;
  }

  const carString = [
    props.data.vehicleInfo.data.regNo.value,
    selectedMakeName,
    props.data.vehicleInfo.data.model.value
  ].join(" ");

  let mileageString = null;
  if(props.data.mileage.isRequired){
    mileageString = " läbisõit: " + props.data.mileage.value + " km";
  }


  let companyRow = null;
  if(props.data.customerInfo.data.isCompany){
    const companyString = [
      props.data.customerInfo.data.company.name.value,
      props.data.customerInfo.data.company.regNo.value,
      props.data.customerInfo.data.company.address.value,
    ].join(" ");

    companyRow = (
      <tr>
        <td><i className="fa fa-building-o"></i> Ettevõte</td>
        <td>{companyString}</td>
      </tr>
    );
  }

  let selectedDatesDisclaimer = null;
  if(timestampsDatesDifferent(props.data.selectedBookingSlot.start, props.data.selectedBookingSlot.end)){
    selectedDatesDisclaimer = (
      <tr>
        <td colSpan="2" className="font-weight-bold">NB! Teenuseid teostatakse mitmel päeval.</td>
      </tr>
    );
  }

  let priceInfo = null;
  if(props.data.totalPrice!==null && isNaN(props.data.totalPrice)===false){
    priceInfo = (
      <tr>
        <td><i className="fa fa-eur"></i> Hind</td>
        <td><strong>{props.data.totalPrice} &euro;</strong></td>
      </tr>
    );
  }

  return (
    <LoadingScreen isLoading={props.isLoading} text={props.loadingTxt}>
      <Row className="justify-content-md-center">
        <Col xs={12}>
          <h3>Kontrolli ja kinnita</h3>
          
          <Table striped bordered hover>
            <tbody>
              <tr>
                <td><i className="fa fa-map-marker"></i> Asukoht</td>
                <td>
                  <span className="d-block">{selectedLocation[0].name}</span>
                  <span className="d-block">{selectedLocation[0].address}</span>
                </td>
              </tr>
              <tr>
                <td><i className="fa fa-cog"></i> Teenus(ed)</td>
                <td>{selectedServices}</td>
              </tr>
              {priceInfo}
              <tr>
                <td><i className="fa fa-calendar-o"></i> Alates</td>
                <td>{formatTimestamp(props.data.selectedBookingSlot.start)}</td>
              </tr>
              <tr>
                <td><i className="fa fa-calendar-o"></i> Kuni</td>
                <td>{formatTimestamp(props.data.selectedBookingSlot.end)}</td>
              </tr>
              {selectedDatesDisclaimer}
              <tr>
                <td><i className="fa fa-address-card-o"></i> Teie nimi</td>
                <td>{props.data.customerInfo.data.nameFirst.value} {props.data.customerInfo.data.nameLast.value}</td>
              </tr>
              <tr>
                <td><i className="fa fa-at"></i> E-mail</td>
                <td>{props.data.customerInfo.data.email.value}</td>
              </tr>
              <tr>
                <td><i className="fa fa-phone"></i> Telefon</td>
                <td>{props.data.customerInfo.data.phone.value}</td>
              </tr>
              {companyRow}
              <tr>
                <td><i className="fa fa-car"></i> Sõiduk</td>
                <td>{carString}{mileageString}</td>
              </tr>
              <tr>
                <td colSpan="2">{props.data.problemDescription}</td>
              </tr>

            </tbody>
          </Table>

        </Col>
      </Row>
      <Row className="justify-content-md-center">
        <Col xs={6}>
          <Button onClick={() => props.btnBackClicked()} variant="light" className="float-left"><i className="fa fa-caret-left"></i> Tagasi muutma</Button>
        </Col>
        <Col xs={6}>
          <Button onClick={() => props.confirmBtnClicked() } variant="success" className="float-right"><i className="fa fa-check"></i> Kinnita broneering</Button>
        </Col>
      </Row>
    </LoadingScreen>
  );


}

export default overview;